
import { UserModule } from '@/store/modules/user'
import { Component, PropSync, Vue, Watch } from 'vue-property-decorator'
import HsPlupload from '@/components/plupload/main.vue'

@Component({
  name: 'multi-file-upload',
  components: {
    HsPlupload
  }
})
export default class MulitiFileUpload extends Vue {
  @PropSync('list', { type: Array, default: () => ([]) })
  private listSync!: any[]

  get token () {
    return UserModule.token
  }

  private loading = !1

  private serverConfigUrl = ''
  private files = []
  private up: any = {}
  public datas:any[] = []
  get status () {
    const files = this.files.length > 0 ? this.files[0] : null
    return files ? (files as any).status : null
  }

  @Watch('files', { deep: !0 })
  private handler () {
    const names = this.datas.map((v: any) => v.name)
    this.files.map((e: any) => {
      if (!names.includes(e.name)) {
        this.datas.push({
          name: e.name,
          size: e.size,
          status: e.status,
          id: e.id
        })
      }
    })
  }

  get allowUpload () {
    if (!this.datas || this.datas.length === 0) return !1
    return this.datas.filter((v) => v.status !== 5).length
  }

  private FileUploaded (up: any, files: any, res: any) {
    const response = JSON.parse(res.response)
    if (response.success) {
      const _files: any = response.fileInfos
      this.datas.map((e: any) => {
        if (_files[0].originalFileName === e.name) {
          e.status = files.status
          e.realName = _files[0].originalFileName
          e.temName = _files[0].newFileName
          e.path = _files[0].savePath
        }
      })
    }
  }

  private UploadComplete () {
    this.loading = !1
  }

  private inputUploader (up: any) {
    this.up = up
    this.files = up.files
  }

  private deleteFile (id: any) {
    const file = this.up.getFile(id)
    this.up.removeFile(file)
    this.datas = this.datas.filter((v: any) => v.id !== id)
  }

  private error (up: any, res: any) {
    if (res.code === -600) {
      this.$message.error('上传文件大小不能超过20MB!')
    } else {
      this.$message.error(res.message)
    }
  }

  public clear () {
    this.datas.map((v: any) => {
      const file = this.up.getFile(v.id)
      this.up.removeFile(file)
    })
    this.datas = []
  }

  mounted () {
    this.datas = []
  }
}
